import React from "react";

const Navigation = ({ onRouteChange, isSignedIn }) => {
    if (isSignedIn) {
        return (
            <nav style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <p onClick={() => onRouteChange('signout')}
                    className="f3 link dim black underline p3 pointer">Sign Out</p>
            </nav>
        );
    } else {
        return (
            <nav style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <p onClick={() => onRouteChange('signin')} className="pa2 f3 link dim black underline p3 pointer">Sign in</p>
                <p onClick={() => onRouteChange('Register')} className="pa2 f3 link dim black underline p3 pointer">Register</p>
            </nav>
        );
    }
}

export default Navigation;